import { calculatePromoPenefits, initialState, stateGetter, stateMutations } from './cartHelper' // calculatePromoPenefits
import { getProvider } from '@/apollo'
import queryMnpInCart from '@/store/modules/checkoutv2/cart/gql/queryMnpInCart'

const BelatedPortingCartModule = {
  namespaced: true,
  state: {
    ...initialState,
    bookedTariff: null,
    bookedAboOption: null,
    bookedPrice: null,
    bookedVolume: null
  },
  getters: {
    ...stateGetter,
    bookedTariff: state => {
      return state.bookedTariff
    },
    bookedAboOption: state => {
      return state.bookedAboOption
    },
    bookedPrice: state => {
      return state.bookedPrice
    },
    bookedVolume: state => {
      return state.bookedVolume
    }
  },
  actions: {
    /* TBD: see cart/OrderCart.js
    async setOrderCartWithPrefetches ({ commit, state, getters, rootGetters }, { ... }) { }
    async queryOrderCart ({ commit, state, getters, rootGetters }, { ... }) { }
    */
    async queryCart ({ commit, state, rootGetters }, { token = null }) {
      let tariffoptions = []
      // Tarif Optionen aus State
      if (state.selectedTariffOptionIds && state.selectedTariffOptionIds.length > 0) {
        tariffoptions = state.selectedTariffOptionIds.map(id => { return { tariffoptionId: id } })
      }
      const product = {
        tariffoptions,
        triggerDefault: true
      }
      let network = null
      if (rootGetters['checkoutv2/belatedPorting/_mnpData/active']) {
        const provider = rootGetters['checkoutv2/belatedPorting/_mnpData/provider']
        network = {
          mnp: true,
          providerKey: provider?.key || null,
          networkKey: provider?.network || null
        }
      }
      const variables = {
        cart: {
          orderContext: { market: 'PUC' },
          product,
          network
        }
      }

      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: queryMnpInCart,
        variables
      }).then((response) => {
        const result = response.data.mnpInCart
        const targetPromotions = result.targetPromotion || []
        commit('setTargetTariff', result.targetTariff)
        commit('setTargetTariffoptions', result.targetTariffoptions?.bookableTariffoptions || [])
        commit('setTargetPromotions', targetPromotions)
        // voucher code & voucher promotions aren't used in belated porting
        commit('setPromoBenefits', calculatePromoPenefits({
          tariff: result.targetTariff,
          tariffoptions: result.targetTariffoptions?.bookableTariffoptions || [],
          promotions: targetPromotions
        }))
        return true
      }).catch((error) => {
        throw error
      })
    }
  },
  mutations: {
    ...stateMutations,
    setBookedTariff (state, tariff) {
      state.bookedTariff = tariff
    },
    setBookedAboOption (state, option) {
      state.bookedAboOption = option
    },
    setBookedPrice (state, price) {
      state.bookedPrice = price
    },
    setBookedVolume (state, volume) {
      state.bookedVolume = volume
    },
    resetState (state) {
      Object.assign(state, {
        ...initialState
      })
    }
  }
}

export default BelatedPortingCartModule
